import {Component} from '@angular/core';

import { Router } from '@angular/router';

import {GlobalState} from '../../../global.state';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';

import { ModalLogout } from '../modals/components/modalLogout/modalLogout.component';
import { EventsService } from '../../services/events/events.service';

@Component({
  selector: 'ba-page-top',
  templateUrl: './baPageTop.html',
  styleUrls: ['./baPageTop.scss']
})
export class BaPageTop {

  public isScrolled:boolean = false;
  public isMenuCollapsed:boolean = false;
  public username:string = '';

  private subscribed;

  constructor(
    private _router:Router,
    private _modalService: NgbModal,
    private _state:GlobalState,
    private _eventService: EventsService,
    private _localStorage:LocalStorageService,
    private _sessionStorage: SessionStorageService
  ) {
    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });
    this.subscribed = _eventService.logout.subscribe((value) => this.logout(value));
  }

  ngOnInit(){
    var userData = this._localStorage.retrieve('user_data');
    if(userData!=null)
      this.username = userData.username.toUpperCase();
  }

  public toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
    return false;
  }

  public scrolledChanged(isScrolled) {
    this.isScrolled = isScrolled;
  }

  private logout(status:boolean){
    if(status){
      this._localStorage.clear();
      this._sessionStorage.clear();
      this._router.navigateByUrl('/');
    }
  }

  public showModal(): void {
    const activeModal = this._modalService.open(ModalLogout, {size: 'sm'});
  }

  ngOnDestroy(){
    this.subscribed.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /app/src/app/theme/components/baPageTop/baPageTop.component.ts